//
import Model from '@/models/Model'

/**
 * SlDetailGroupedOffer
 * @class
 */
export default class SlDetailGroupedOffer extends Model {
  /**
   * Return wh product name
   */
  get wh_product_name() {
    return this.getProperty('wh_product.name', '-')
  }
  /**
   * SlDetailGroupedOffer
   * @return {String}
   */
  resource() {
    return 'sl_detail_grouped_offer'
  }
}
